import { useState } from "react";
import { motion } from "framer-motion";
import { Menu, X } from "lucide-react";

const links = [
  { label: "About", href: "#about" },
  { label: "Courses", href: "#courses" },
  { label: "Mentorship", href: "#mentorship" },
  { label: "FAQs", href: "#faq" },
  { label: "Contact", href: "#contact" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);

  const scrollTo = (e, href) => {
    e.preventDefault();
    setOpen(false);
    document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <motion.header
      initial={{ y: -40, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 1, delay: 1.2, ease: [0.25, 1, 0.5, 1] }}
      className="fixed top-0 left-0 right-0 z-50 bg-[#FAFAF8]/90 backdrop-blur-md border-b border-[#0E0E0E]/10"
      data-testid="main-navbar"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 h-16 flex items-center justify-between gap-3">
        <a
          href="#top"
          onClick={(e) => scrollTo(e, "#top")}
          data-testid="nav-logo"
          className="font-heading font-extrabold text-sm sm:text-lg tracking-[0.1em] sm:tracking-[0.12em] uppercase text-[#0E0E0E] whitespace-nowrap"
        >
          Dr. Kshama <span className="text-[#C6A45C]">Chandan</span>
        </a>
        <nav className="hidden md:flex items-center gap-9">
          {links.map((l) => (
            <a
              key={l.label}
              href={l.href}
              onClick={(e) => scrollTo(e, l.href)}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="link-underline font-heading text-sm font-medium text-[#0E0E0E]/80 hover:text-[#0E0E0E] transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>
        <div className="flex items-center gap-2.5">
          <a
            href="https://wa.me/919321967864"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="nav-whatsapp-cta"
            className="font-heading text-xs sm:text-sm font-bold bg-[#0E0E0E] text-[#FAFAF8] px-4 sm:px-6 py-2 sm:py-2.5 rounded-xl hover:bg-[#C6A45C] transition-colors duration-300 whitespace-nowrap"
          >
            <span className="hidden sm:inline">Enquire Today</span>
            <span className="sm:hidden">Enquire</span>
          </a>
          <button
            onClick={() => setOpen(!open)}
            data-testid="nav-mobile-menu-btn"
            aria-label="Toggle menu"
            className="md:hidden inline-flex items-center justify-center w-9 h-9 rounded-lg border border-[#0E0E0E]/15 text-[#0E0E0E]"
          >
            {open ? <X size={18} /> : <Menu size={18} />}
          </button>
        </div>
      </div>
      {open && (
        <nav className="md:hidden bg-[#FAFAF8] border-t border-[#0E0E0E]/10 px-6 py-4 flex flex-col gap-1" data-testid="nav-mobile-menu">
          {links.map((l) => (
            <a
              key={l.label}
              href={l.href}
              onClick={(e) => scrollTo(e, l.href)}
              data-testid={`nav-mobile-link-${l.label.toLowerCase()}`}
              className="font-heading font-semibold text-base text-[#0E0E0E] py-2.5 border-b border-[#0E0E0E]/5 last:border-none"
            >
              {l.label}
            </a>
          ))}
        </nav>
      )}
    </motion.header>
  );
};
